<div class="albums-wrapper" *ngIf="playlists">
    <div class="album" *ngFor="let playlist of playlists" (click)="goToPage(playlist?.fields?.referenceId)">
        <div class="cover">
            <img *ngIf="!playlist?.fields?.artwork" src="https://via.placeholder.com/150/1B1B1C/030303" />
            <img *ngIf="playlist?.fields?.artwork" src="{{ cleanUrl(playlist?.fields?.artwork) }}?resize=300,300" />
        </div>
        <strong class="title">{{ playlist?.fields?.title }}</strong>
        <small class="muted">{{ playlist?.fields?.description }}</small>
    </div>
</div>